import BaseComponent from '../../../../common/js/BaseComponent';
import Helper from '../../../../common/utils/helper';

export default class ZipCitySelector extends BaseComponent {
    protected citiesSearchUrl: string;

    protected initAdditionalVar(): void {
        this.citiesSearchUrl = this.view.dataset.citiesSearchUrl;
    }

    init(): any {
        // Chargement du listener pour executer des requètes de recherche de villes dans la base de données
        // de tanguy correspondant au code postal saisie
        this.initZipcodeEvent();
        // Chargement de la liste de ville en fonction du code postal en cas de chargement d'un formulaire
        // déjà enregistré en base de données
        this.initCityListIfZipcodeIsFilled();
    }

    private getZipField(): HTMLInputElement {
        return document.getElementById('zip');
    }

    private getCityField(): HTMLSelectElement {
        return document.getElementById('city');
    }

    /**
     * Initialisation d'un listener pour remplir un menu déroulant avec les villes correspondant au code
     * postal saisi.
     *
     * @private
     */
    private initZipcodeEvent() {
        const zipField = this.getZipField();
        if (zipField !== null) {
            zipField.addEventListener('keyup', this.debounce((event: TriggeredEvent) => {
                    this.searchCities(event.target);
                }, 750)
            );
        }
    }

    /**
     * Chargement des villes correspondant au code postal pré-renseigné en cas d'édition d'une adresse existante
     *
     * @private
     */
    private initCityListIfZipcodeIsFilled() {
        const zipField = this.getZipField();
        if (zipField !== null && zipField.value.length > 0) {
            // Chargement des villes correspondant au code postal puis auto-selection de la ville
            this.searchCities(zipField);
        }
    }

    /**
     * Forçace de l'option selectionnées si le data-selected-value est renseigné, dans le cas d'une édition
     * de formulaire. Cela va permettre d'aller selectionner une option après chargement
     *
     * TODO Peut être prévoir à minima d'ajouter l'option si elle n'éxiste pas ou n'a pas été chargé dans
     *  \ le menu déroulant
     *
     * @private
     */
    private selectCityOption() {
        const cityField = this.getCityField();

        if (cityField !== null && cityField.options.length > 0 && cityField.dataset.selectedValue !== null) {
            // Parcours des villes pour forcer la selection sur la valeur enregistrée en base de données (en mode edition)
            Array.from(cityField.options).forEach((optionElement: HTMLOptionElement) => {
                if (optionElement.value === cityField.dataset.selectedValue) {
                    optionElement.selected = true;
                }
            });
        }
    }

    /**
     * Réinitialisation par vidage du contenu (options) du champ select des villes
     *
     * @private
     */
    private resetCitiesDropdown() {
        // Récupération du champ select
        var cityField = document.getElementById('city');
        cityField.length = 0;
    }

    /**
     * Lancement de la recherche AJAX avec les bons paramètres en prenant la valeur de code postal saisi
     *
     * @param zipField
     * @private
     */
    private searchCities(zipField: HTMLInputElement): Promise<void> {
        const fetchUrl = this.citiesSearchUrl + '?' + new URLSearchParams({
            autocomplete: zipField.value ?? '',
            source: 'm3', // Source m3 (tanguy), alternative : '6tm'
        });
        fetch(fetchUrl, {
            method: 'GET',
            headers: Helper.createFetchHeader(),
        })
            .then((response) => Promise.all([response, response.text()]))
            .then(([, data]) => {
                // S'il y a des données retournées, on va générer un menu déroulant (select)
                // avec les noms de villes retournées.
                var response = JSON.parse(data);
                this.resetCitiesDropdown();
                if (response.results !== null) {
                    // Remplissage du menu déroulant avec des options basées sur les villes retournées
                    this.populateCitiesDropdown(response.results);
                    // Autoselection de la valeur qui était enregistrée sur le champ ville si on la retrouve
                    this.selectCityOption();
                }
            });
    }

    private populateCitiesDropdown(cities) {
        // Récupération du champ select
        var cityField = this.getCityField();

        if (cities.length > 0) {
            // Chargement de l'entrée par défaut avec valeur NULLE (ou vide) qui permet de bloquer le
            // champ s'il est requis
            this.addOptionToCitiesDropdown(cityField, '', (cityField.dataset.label ?? 'Ville'));

            // Remplissage du champ select avec les villes récupérées
            for (const key in cities) {
                this.addOptionToCitiesDropdown(cityField, cities[key]['value'], cities[key]['label']);
            }
        } else {
            // Si pas de villes, retournées, on informe l'utilisateur
            this.addOptionToCitiesDropdown(cityField, '', cityField.dataset.labelNoData ?? 'Pas de données');
        }
    }

    /**
     * Ajout d'une option dans le champ SELECT des villes
     *
     * @param field Champ Select
     * @param value
     * @param label
     * @private
     */
    private addOptionToCitiesDropdown(field: HTMLSelectElement, value: string, label: string):HTMLSelectElement {
        const optionDefault = document.createElement("option");
        optionDefault.value = value;
        optionDefault.text = label;
        field.add(optionDefault);

        return field;
    }
}
